"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
CardController.$inject = ['$scope', '_card'];
function CardController($scope, _card) {
    $scope.type = 0;
    $scope.sum = [];
    $scope.details = [];
    $scope.loading = false;
    refreshData();
    function refreshData() {
        $scope.loading = true;
        _card.getFinanceSum($scope.type).then(function (response) {
            $scope.sum = response;
            var dateObj = new Date(response.updated_at);
            var sum_date = dateObj.toLocaleDateString('sr-RS', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
            var sum_date_time = dateObj.toLocaleTimeString('sr-RS', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            });
            $scope.sum.date = sum_date;
            $scope.sum.date_time = sum_date_time;
        }, function (error) {
        });
        _card.getFinanceDetails($scope.type).then(function (response) {
            $scope.details = response.map(function (item) {
                var dateObj = new Date(item.date);
                var valueDateObj = new Date(item.value_date);
                item.date = dateObj.toLocaleDateString('sr-RS', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                });
                item.value_date = valueDateObj.toLocaleDateString('sr-RS', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                });
                return item;
            });
            $scope.loading = false;
        }, function (error) {
            $scope.loading = false;
        });
    }
    $scope.changeType = function (type) {
        if (type != $scope.type) {
            $scope.type = type;
            refreshData();
        }
    };
}
exports.CardController = CardController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/card/controllers/CardController.js
// module id = 457
// module chunks = 0